<script setup lang="ts">
import HorizontalAlignChildrenWrapper from '@components/layout-wrapper/horizontal-align-children-wrapper.vue';
import Icon from '@components/icons/icon.vue';
import Text from '@components/text.vue';
import ContextMenu from '@components/context-menu.vue';
import { closeLoader, openLoader } from '@utils/loader-util.js';
import apiClient from '@src/api/api-client.js';
import { addToast } from '@utils/toast-util.js';
import { createErrorModal, createModal } from '@utils/modal-util.js';
import ModalPrinterSettings from '@src/application/modals/modal-printer-settings.vue';
import mobileDetectStore from '@src/application/store/mobile-detect-store.js';
import { useAuthComposable } from '@src/auth/composable/auth-composable.ts';
import { useCurrentUserComposable } from '@src/user/composable/current-user-composable.ts';
import useCurrentUserFavoriteComposable from '@src/favorite/composable/current-user-favorite-composable.ts';

const { currentUser } = useCurrentUserComposable();

const { isLoggedIn, authToken } = useAuthComposable();
const { favorites } = useCurrentUserFavoriteComposable();

const actions = [
    {
        label: 'Tageslogin drucken',
        callback: async () => {
            openLoader();
            await apiClient.post('/be/print-login-token');
            closeLoader();
            addToast('Tageslogin wurde gedruckt');
        },
    },
    {
        label: 'Login-PIN anzeigen',
        callback: async () => {
            openLoader();
            const loginToken = (await apiClient.post('/be/generate-short-term-login-token')).data;
            closeLoader();
            await createErrorModal('Login-PIN', loginToken.token);
        },
    },
    {
        label: 'Druckereinstellungen',
        callback: async () => {
            await createModal(
                'Druckereinstellungen',
                ModalPrinterSettings,
                'save',
                'abort',
                null,
                '1',
            );
        },
    },
    {
        label: 'Logout',
        callback: () => {
            authToken.value = null;
            currentUser.value = null;
            favorites.value = null;
            window.location.href = '/';
        },
    },
];
</script>

<template>
    <ContextMenu
        label="Einstellungen"
        :hide-label-low-screen="true"
        :actions="actions"
        :position="mobileDetectStore.isMobile.data ? 'bottom_right' : 'bottom_left'"
    >
        <HorizontalAlignChildrenWrapper v-if="isLoggedIn()" :class="$style.logged_in" gap="1" :wrap-on-small-screen="false" :center-children="true">
            <Icon icon="user-circle" :icon-color="currentUser?.dynamicPickUser?.pickPrioritizingItems ? 'red' : 'default'"/>
            <Text v-if="currentUser" :class="$style" :bold="true">{{ currentUser.firstName }} {{ currentUser.lastName }}</Text>
        </HorizontalAlignChildrenWrapper>
    </ContextMenu>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

.logged_in {
    padding: .75em 0;
    cursor: pointer;

    @media (max-width: 25em) {
        font-size: .9em;
    }
}
</style>
